<template>
  <div v-if="noteCards.length" class="pl-8">
    <v-btn x-small text @click="showArchive = !showArchive" class="ml-3">
      {{ noteCards.length }} Hidden 
      <oh-v-icon :name="!showArchive ? 'md-keyboardarrowdown' : 'md-keyboardarrowup'"></oh-v-icon>
    </v-btn>
    <hidden-item
      v-show="showArchive"
      v-for="item in noteCards"
      :item="item"
      :key="item.id"
      @revert="unHideNote({ pageId: item.id, targetPageId: pageId })"
    ></hidden-item>
  </div>
</template>

<script>
import { pagesModule } from '@/store/database/pagesModule';
import { computed, ref } from '@vue/composition-api';
import HiddenItem from './Outline/HiddenItem.vue';
import { unHideNote } from '@/components/ContextDoc/use/useDocActions';

export default {
  props: ['pageId', 'domainId'],
  components: { HiddenItem },
  setup(props) {
    const showArchive = ref(false);
    const noteCards = computed(() => {
      const ncModule = pagesModule
        .where('context', '==', props.domainId)
        .where('localArchives', 'array-contains', props.pageId)
        .where('toDelete', '!=', true)
        .data.values();

      const parentPage = pagesModule.doc(props.pageId).data;
      const hiddenNotesObj = parentPage.hiddenNotes ? parentPage.hiddenNotes : {};

      const hiddenNotes = Object.values(hiddenNotesObj);
      const hNotes = hiddenNotes.map(page => {
        const n = pagesModule.doc(page.pageId).data;
        const date = page.hideDate.toDate ? page.hideDate.toDate() : page.hideDate;
        return { ...n, noteCardSortDate: date };
      });
      // const localCards = ncModule.filter(nc => {
      //   const originIds = nc.noteCardOrigin ? nc.noteCardOrigin.map(o => o.id) : [];
      //   return originIds.includes(props.pageId);
      // });

      const oldHidden = ncModule.map(n => {
        const date = n.noteCardCreated.toDate ? n.noteCardCreated.toDate() : n.noteCardCreated;
        return { ...n, noteCardSortDate: date };
      });

      return [...oldHidden, ...hNotes];
    });

    return { noteCards, showArchive, unHideNote };
  }
};
</script>

<style></style>
